<!-- max-height rather than a fixed height: `height: 90vh` kept this dialog at full
     viewport height even when the form was short, which left a large empty gap
     between the last field and the footer. -->
<p-dialog [visible]="visible" (visibleChange)="closeDialog()"
  [header]="isEditMode ? 'Edit Employee' : 'Add Employee'" [modal]="true" styleClass="dialog-xl emp-form-dialog"
  [dismissableMask]="true" [closable]="true"
  [style]="{'max-height': '90vh'}"
  [contentStyle]="{'display':'flex','flex-direction':'column','padding':'0','overflow':'hidden','min-height':'0'}">

  <!-- Options loading -->
  <div *ngIf="loadingOptions" class="emp-form-loading">
    <i class="pi pi-spin pi-spinner"></i>
    <span>Loading form data...</span>
  </div>

  <!-- Scrollable form body -->
  <div class="emp-form-body" *ngIf="!loadingOptions">
    <div class="form-dialog-form form-dialog-compact">
      <div class="form-dialog-container">

        <!-- SECTION: System Access & Role -->
        <div class="emp-section-title"><i class="pi pi-briefcase"></i> System Access & Role</div>
        <div class="form-row two-columns">
          <div class="field" [class.field-invalid]="fieldTouched['name'] && !form.name.trim()">
            <label>Full Name <span class="required-star">*</span></label>
            <input pInputText [(ngModel)]="form.name" placeholder="e.g. John Smith" autocomplete="off" (blur)="fieldTouched['name'] = true" />
            <small class="field-error" *ngIf="fieldTouched['name'] && !form.name.trim()">Full name is required</small>
          </div>
          <div class="field" [class.field-invalid]="fieldTouched['email'] && form.email && !isValidEmail(form.email)">
            <label>Work Email</label>
            <input pInputText type="email" [(ngModel)]="form.email"
              placeholder="john@bistecglobal.com" autocomplete="off" (blur)="fieldTouched['email'] = true" />
            <small class="field-error" *ngIf="fieldTouched['email'] && form.email && !isValidEmail(form.email)">Invalid email address</small>
          </div>
        </div>

        <div class="form-row two-columns">
          <div class="field" [class.field-invalid]="fieldTouched['roleIds'] && (!form.roleIds || form.roleIds.length === 0)">
            <label>Roles <span class="required-star">*</span></label>
            <p-multiSelect [(ngModel)]="form.roleIds" [options]="roleOptions" optionLabel="label"
              optionValue="value" placeholder="Select roles" appendTo="body" [showClear]="true"
              [filter]="true" [maxSelectedLabels]="3" (onBlur)="fieldTouched['roleIds'] = true" />
            <small class="field-error" *ngIf="fieldTouched['roleIds'] && (!form.roleIds || form.roleIds.length === 0)">At least one role is required</small>
          </div>
          <div class="field" [class.field-invalid]="fieldTouched['serviceGroupIds'] && (!form.serviceGroupIds || form.serviceGroupIds.length === 0)">
            <label>Service Groups <span class="required-star">*</span></label>
            <p-multiSelect [(ngModel)]="form.serviceGroupIds" [options]="serviceGroupOptions"
              optionLabel="label" optionValue="value" placeholder="Select service groups" appendTo="body"
              [showClear]="true" [filter]="true" [maxSelectedLabels]="3" (onBlur)="fieldTouched['serviceGroupIds'] = true" />
            <small class="field-error" *ngIf="fieldTouched['serviceGroupIds'] && (!form.serviceGroupIds || form.serviceGroupIds.length === 0)">At least one service group is required</small>
          </div>
        </div>

        <div class="form-row two-columns">
          <div class="field">
            <label>Designation</label>
            <p-select [(ngModel)]="form.designationId" [options]="designationOptions"
              optionLabel="label" optionValue="value" placeholder="Select designation" [showClear]="true" [filter]="true" filterPlaceholder="Search…" appendTo="body" />
          </div>
          <div class="field">
            <label>Category</label>
            <p-select [(ngModel)]="form.categoryId" [options]="categoryOptions"
              optionLabel="label" optionValue="value" placeholder="Select category" [showClear]="true" [filter]="true" filterPlaceholder="Search…" appendTo="body" />
          </div>
        </div>

        <div class="form-row two-columns">
          <div class="field">
            <label>Head of Department</label>
            <p-select [(ngModel)]="form.headOfDepartmentId" [options]="headOfDepartmentOptions"
              optionLabel="label" optionValue="value" placeholder="Select HOD" [showClear]="true" [filter]="true" filterPlaceholder="Search…" appendTo="body" />
          </div>
          <div class="field">
            <label>Employment Type</label>
            <p-select [(ngModel)]="form.employmentType" [options]="employmentTypeOptions"
              optionLabel="label" optionValue="value" placeholder="Select type" [showClear]="true" appendTo="body" />
          </div>
        </div>

        <div class="form-row two-columns">
          <div class="field">
            <label>Joining Date</label>
            <!-- p-datepicker, not <input type="date">: the native input renders the
                 browser's own calendar, which is why this form's date field looked
                 unlike every other form. Binds a Date (joiningDatePicker) and is
                 converted back to the API's 'YYYY-MM-DD' string on save. -->
            <p-datepicker inputId="joiningDate" [(ngModel)]="joiningDatePicker"
              [showIcon]="true" dateFormat="D, M d, yy" placeholder="Select joining date"
              [showOnFocus]="false" [autoZIndex]="true" appendTo="body" />
          </div>
          <div class="field">
            <label>Bistec Apex Entra ID Group</label>
            <p-select [(ngModel)]="form.entraIdGroup" [options]="entraIdGroupOptions"
              optionLabel="label" optionValue="value" placeholder="Select Entra ID group"
              [showClear]="true" [filter]="true" filterPlaceholder="Search…" appendTo="body" />
          </div>
        </div>

        <div class="form-row two-columns">
          <div class="field" *ngIf="isEditMode">
            <label>Status</label>
            <div class="field-toggle">
              <p-button [label]="form.isActive ? 'Active' : 'Inactive'"
                [severity]="form.isActive ? 'success' : 'secondary'" [outlined]="!form.isActive"
                (onClick)="toggleActive()" size="small" />
            </div>
          </div>
          <!-- Only meaningful once the employee is inactive. Pre-filled with today by
               toggleActive(), but editable so a leaver recorded weeks late can be backdated
               to their real last working day. -->
          <div class="field" *ngIf="isEditMode && !form.isActive">
            <label>Inactive Date</label>
            <p-datepicker inputId="inactiveDate" [(ngModel)]="inactiveDatePicker"
              [showIcon]="true" dateFormat="D, M d, yy" placeholder="Select last working day"
              [showOnFocus]="false" [autoZIndex]="true" appendTo="body" />
            <small class="field-hint">Their last working day — backdate this if they left earlier.</small>
          </div>
        </div>

        <!-- SECTION: Personal Information -->
        <div class="emp-section-title"><i class="pi pi-user"></i> Personal Information</div>
        <div class="form-row two-columns">
          <div class="field">
            <label>ID Number</label>
            <input pInputText [(ngModel)]="form.idNumber" placeholder="National ID / Passport" autocomplete="off" />
          </div>
          <div class="field">
            <label>Mobile Number</label>
            <input pInputText [(ngModel)]="form.mobileNumber" placeholder="+94 7X 123 4567" autocomplete="off" />
          </div>
        </div>

        <div class="form-row two-columns">
          <div class="field" [class.field-invalid]="fieldTouched['personalEmail'] && form.personalEmail && !isValidEmail(form.personalEmail)">
            <label>Personal Email</label>
            <input pInputText type="email" [(ngModel)]="form.personalEmail" placeholder="personal@email.com" autocomplete="off" (blur)="fieldTouched['personalEmail'] = true" />
            <small class="field-error" *ngIf="fieldTouched['personalEmail'] && form.personalEmail && !isValidEmail(form.personalEmail)">Invalid email address</small>
          </div>
          <div class="field">
            <label>LinkedIn URL</label>
            <input pInputText [(ngModel)]="form.linkedInUrl" placeholder="https://linkedin.com/in/..." autocomplete="off" />
          </div>
        </div>

        <div class="form-row two-columns">
          <div class="field">
            <label>Residential Address</label>
            <input pInputText [(ngModel)]="form.residentialAddress" placeholder="Permanent address" autocomplete="off" />
          </div>
          <div class="field">
            <label>Current Address</label>
            <input pInputText [(ngModel)]="form.currentAddress" placeholder="Current address" autocomplete="off" />
          </div>
        </div>

        <div class="form-row two-columns">
          <div class="field">
            <label>Emergency Contact Name</label>
            <input pInputText [(ngModel)]="form.emergencyContactName" placeholder="Contact name" autocomplete="off" />
          </div>
          <div class="field">
            <label>Emergency Contact Number</label>
            <input pInputText [(ngModel)]="form.emergencyContactNumber" placeholder="+94 7X 123 4567" autocomplete="off" />
          </div>
        </div>

        <!-- CV Upload -->
        <div class="form-row">
          <div class="field">
            <label>CV / Resume <span class="field-hint">(PDF, DOC, DOCX — max 10 MB)</span></label>
            <div class="cv-upload-zone" [class.cv-has-file]="form.cvAttachmentUrl">
              <ng-container *ngIf="!form.cvAttachmentUrl && !cvUploading">
                <label class="cv-upload-label" for="cvFileInput">
                  <i class="pi pi-upload"></i>
                  <span>Click to upload CV</span>
                </label>
                <input id="cvFileInput" type="file" accept=".pdf,.doc,.docx" (change)="onCvFileSelected($event)" style="display:none" />
              </ng-container>
              <ng-container *ngIf="cvUploading">
                <i class="pi pi-spin pi-spinner"></i>
                <span>Uploading...</span>
              </ng-container>
              <ng-container *ngIf="form.cvAttachmentUrl && !cvUploading">
                <i class="pi pi-file-pdf cv-file-icon"></i>
                <span class="cv-file-name">{{ cvFileName }}</span>
                <a [href]="form.cvAttachmentUrl" target="_blank" class="cv-action-btn" pTooltip="Open" tooltipPosition="top">
                  <i class="pi pi-external-link"></i>
                </a>
                <button type="button" class="cv-action-btn cv-remove-btn" pTooltip="Remove" tooltipPosition="top" (click)="removeCv()">
                  <i class="pi pi-times"></i>
                </button>
              </ng-container>
            </div>
          </div>
        </div>

        <!-- SECTION: System Exclusions -->
        <div class="emp-section-title"><i class="pi pi-ban"></i> System Exclusions</div>
        <div class="form-row full-width-row">
          <div class="field">
            <div class="checkbox-group">
              <div class="checkbox-item">
                <p-checkbox [(ngModel)]="form.excludeFromAllocation" [binary]="true" inputId="excAlloc" />
                <label for="excAlloc" class="checkbox-label">Exclude from Allocation</label>
              </div>
              <div class="checkbox-item">
                <p-checkbox [(ngModel)]="form.excludeFromForecast" [binary]="true" inputId="excForecast" />
                <label for="excForecast" class="checkbox-label">Exclude from Forecast</label>
              </div>
              <!-- Its own flag, not shared with Forecast: someone can belong in the revenue
                   forecast while being pointless to capacity-plan a year out, and vice versa. -->
              <div class="checkbox-item">
                <p-checkbox [(ngModel)]="form.excludeFromFutureAllocation" [binary]="true"
                            inputId="excFutureAlloc" />
                <label for="excFutureAlloc" class="checkbox-label">Exclude from Future Allocation</label>
              </div>
              <div class="checkbox-item">
                <p-checkbox [(ngModel)]="form.excludeFromTimesheet" [binary]="true" inputId="excTimesheet" />
                <label for="excTimesheet" class="checkbox-label">Exclude from Timesheet</label>
              </div>
              <!-- Shown on both hosts (Onboarding and Employee Management) and in both modes, so
                   someone who forgot to tick it at creation can still start onboarding later.
                   Ticking only ever CREATES — an existing record is shown ticked and disabled,
                   because unticking must never delete tasks that may be part-complete. -->
              <div class="checkbox-item">
                <p-checkbox [(ngModel)]="startOnboarding" [binary]="true" inputId="startOnboarding"
                  [disabled]="isEditMode && hasOnboardingRecord" />
                <label for="startOnboarding" class="checkbox-label">Start onboarding checklist</label>
              </div>
            </div>
            <small class="field-hint">
              <ng-container *ngIf="isEditMode && hasOnboardingRecord">
                Onboarding has already been started for this employee. Remove it from the Onboarding module if it was created by mistake.
              </ng-container>
              <ng-container *ngIf="!(isEditMode && hasOnboardingRecord)">
                {{ startOnboarding
                  ? 'Onboarding tasks will be created for this employee.'
                  : 'No onboarding checklist — use this for staff who joined before this system, or were onboarded outside it.' }}
              </ng-container>
            </small>
          </div>
        </div>

      </div>
    </div>
  </div>

  <!-- Always-visible footer — flex sibling of emp-form-body inside p-dialog-content -->
  <div class="emp-form-footer">
    <p-button label="Reset" icon="pi pi-refresh" (onClick)="reset()" [text]="true" severity="secondary" />
    <p-button label="Cancel" icon="pi pi-times" (onClick)="closeDialog()" severity="secondary" [outlined]="true" />
    <p-button label="Save" icon="pi pi-check" (onClick)="save()" severity="primary" [loading]="saving" />
  </div>

</p-dialog>
